// https://www.npmjs.com/package/v-mask
import Vue from 'vue'
import { VueMaskDirective } from 'v-mask'

Vue.directive('mask', VueMaskDirective)
